import { styled, MenuItem } from '@mui/material';

import {
  MENU_ITEM_GRID_AVATAR,
  MENU_ITEM_GRID_NAME,
  MENU_ITEM_GRID_STATUS,
  MENU_ITEM_GRID_ACCOUNT
} from './MenuItem.constants';

interface StyledMenuItemProps {
  isCurrentUser?: boolean;
}

const menuItemGridForSelectedUserTemplateArea = `
"${MENU_ITEM_GRID_AVATAR} ${MENU_ITEM_GRID_NAME}"
"${MENU_ITEM_GRID_AVATAR} ${MENU_ITEM_GRID_ACCOUNT}"
"${MENU_ITEM_GRID_AVATAR} ${MENU_ITEM_GRID_STATUS}"
`;

const menuItemGridForUserTemplateArea = `
"${MENU_ITEM_GRID_AVATAR} ${MENU_ITEM_GRID_NAME}"
"${MENU_ITEM_GRID_AVATAR} ${MENU_ITEM_GRID_ACCOUNT}"
"${MENU_ITEM_GRID_AVATAR} ${MENU_ITEM_GRID_STATUS}"
`;

export const StyledMenuItem = styled(MenuItem, {
  shouldForwardProp: (prop: PropertyKey) => prop !== 'isCurrentUser'
})<StyledMenuItemProps>`
  display: grid;
  grid-template-columns: 40px 1fr;
  column-gap: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => theme.spacing(1.5, 2)};
  align-items: center;
  width: 216px;

  ${({ isCurrentUser }) =>
    isCurrentUser
      ? `
    grid-template-areas: ${menuItemGridForSelectedUserTemplateArea};
    grid-template-rows: repeat(3, auto);
  `
      : `
    grid-template-areas: ${menuItemGridForUserTemplateArea};
    grid-template-rows: repeat(2, auto);
  `}
`;
